import { render, staticRenderFns } from "./DownloadAdsMobile.vue?vue&type=template&id=bc1b0cc6"
import script from "./DownloadAdsMobile.vue?vue&type=script&lang=js"
export * from "./DownloadAdsMobile.vue?vue&type=script&lang=js"
import style0 from "./DownloadAdsMobile.vue?vue&type=style&index=0&id=bc1b0cc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports